module.exports = __webpack_public_path__ + "img/safe.31b3b7b0.png";